"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarouselNavControls = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PhotoCarouselNavControlsMixin = require("../../mixins/components/PhotoCarouselNavControlsMixin");
var StyledPhotoCarouselNavControls = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPhotoCarouselNavControls",
  componentId: "c11n-8-107-0__sc-igi7la-0"
})(["", ""], _PhotoCarouselNavControlsMixin.PhotoCarouselNavControlsMixin);
exports.StyledPhotoCarouselNavControls = StyledPhotoCarouselNavControls;